import * as Sentry from "@sentry/nuxt";

if (useRuntimeConfig().public.sentryDSN) {
  Sentry.init({
    dsn: useRuntimeConfig().public.sentryDSN,

    tracesSampleRate: 1.0,

    debug: false,
  });
}
